import { FamilyMemberType } from '../familyTree.duck';

export const getMemberIdsFromMembers = (members: FamilyMemberType[]): string[] => {
  const memberIds = members
    .map((member: NonNullable<FamilyMemberType>) => member._id ?? '')
    .filter((m) => m !== '');

  return memberIds;
};
